import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, Inject } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import * as Tokens from '@shared/core/tokens';

@Component({
    selector: 'shared-forms-terms',
    templateUrl: './forms-terms.shared.component.html',
    styleUrls: ['./forms-terms.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormsTermsComponent {
    @Input() public label: string = 'Submitting this form you are agreeing to our';
    @Input() public terms: string = 'terms & conditions';
    @Input() public privacyPolicy: string = 'privacy policy';

    @Output() public onClick: EventEmitter<Event> = new EventEmitter();

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public controllers: Controllers,
    ) { }

    public handleTermsAndConditionsClick($event: Event): void {
        this.onClick.emit($event);
        this.controllers.appSettings.onTermsAndConditionsClick();
    }

    public handlePrivacyPolicyClick($event: Event): void {
        this.onClick.emit($event);
        this.controllers.appSettings.onPrivacyPolicyClick();
    }
}
